import { render, staticRenderFns } from "./TenantOnboarding.vue?vue&type=template&id=0b52e463&scoped=true"
import script from "./TenantOnboarding.vue?vue&type=script&lang=js"
export * from "./TenantOnboarding.vue?vue&type=script&lang=js"
import style0 from "./TenantOnboarding.vue?vue&type=style&index=0&id=0b52e463&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52e463",
  null
  
)

export default component.exports